import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';

import { useUIAction } from '../../../contexts/UIContext';

import TextButton from '../TextButton';

const NewTagOption = ( { addTag } ) => {
	const {
		setTag,
		setOnTagModalClose
	} = useUIAction();

	const handleClick = useCallback( e => {
		e.stopPropagation();
		setTag();
		setOnTagModalClose( addTag );
	}, [
		addTag,
		setTag,
		setOnTagModalClose
	] );

	return (
		<TextButton
			buttonText="Add New Tag"
			onClick={ handleClick }
			style={ {
				color: '#4183c4',
				margin: '-3em -2.33333334rem',
				width: 'calc(100% + 2.33333334rem)',
				height: '3em',
				position: 'relative',
				left: '1.16666667rem'
			}}
		/>
	);
};

NewTagOption.propTypes = { addTag: PropTypes.func.isRequired };

export default memo( NewTagOption );
